import { createReducer } from '@ngrx/store';
import { permissionReducer } from '@modules/permissions/store/permission.reducers';
import { roleReducer } from '@modules/roles/store/role.reducers';
import { dashboardStoreKey } from './store.selector';
import { InitialStoreState } from './store.state';
import { tokenReducer } from './token/token.reducers';
import {AuthLogoutAction} from '@modules/users/store/user.actions';
import { userReducer } from '@modules/users/store/user.reducers';


export const rootReducers = createReducer(
  InitialStoreState,
  ...permissionReducer,
  ...roleReducer,
  ...userReducer,
  ...tokenReducer,
);

export function getStoreReducers() {
  return {
    [dashboardStoreKey]: rootReducers
  };
}

export function persistStoreReducer(reducer: any) {
  return function (state: any, action: any) {
    if (action.type !== AuthLogoutAction.type && state) {
      Object.keys(state)
        .filter(key => [dashboardStoreKey].includes(key))
        .forEach(key => {
          const currentTypes = userReducer.map(r => r.types[0]);

          if (currentTypes.includes(action.type)) {
            const newLocalStorage = Object.assign({}, state[key], { ...action });
            delete newLocalStorage.type;

            localStorage.setItem(key, JSON.stringify(newLocalStorage));
          }
        });
    }

    return reducer(state, action);
  };
}
